import { render, staticRenderFns } from "./ServiceStatusUpdateHeader.vue?vue&type=template&id=680115a2&scoped=true&"
import script from "./ServiceStatusUpdateHeader.vue?vue&type=script&lang=ts&"
export * from "./ServiceStatusUpdateHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceStatusUpdateHeader.vue?vue&type=style&index=0&id=680115a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680115a2",
  null
  
)

export default component.exports